import LogsController from 'cio/pods/logs/list/controller';
import { action } from '@ember/object';
import { ActivityLogType, LOG_TYPES_FOR_OBJECTS } from 'cio/utils/activity-log-types';
import CustomerModel from 'cio/models/customer';
import { inject as service } from '@ember/service';
import DS from 'ember-data';

export default class ActivityController extends LogsController {
  @service store!: DS.Store;
  declare model: CustomerModel;

  queryLogs(query: Record<string, any>) {
    return this.model.queryLogs(query);
  }

  hiddenTypes = [ActivityLogType.ProfileDelete, ...LOG_TYPES_FOR_OBJECTS];

  get objectTypes() {
    return this.store.peekAll('object-type').toArray();
  }

  @action
  onNameChange(name: string) {
    this.name = name;
    this.selected = '';
  }

  @action
  onTypeChange(type: string) {
    this.type = type;
    this.selected = '';
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'person.activity': ActivityController;
  }
}
